$(document).ready(function() {
	window.__varebestillingLoaded = true;
	console.log('[varebestilling] script loaded');
	var ajaxPath = '/includes/varebestilling/ajax.php';
	const ajaxPathGetProductsModal = '/action/product-order/get-product-order-modal';
	const ajaxPathSaveProductOrder = '/action/product-order/save-product-order';
	const ajaxPathTempSaveProduct = '/action/product-order/temp-save-product';
	const ajaxPathGetSearchResult = '/action/product-order/get-search-result';
	const ajaxPathGetSendMailModal = '/action/product-order/get-send_mail_modal';
	const ajaxPathSendProductOrderMail = '/action/product-order/send-product-order-mail';
	const ajaxPathDeleteProductOrder = '/action/goods-receipt/delete-product-order';
	let ajaxLocked = false;
	let modalParentElementInDOM = $('div#content');
	let modalTitle = '';
	let modalMessage = '';
	let modalButtonText = 'Lukk';
	let modalAlertType = '';

	var $_GET = {};
	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){$_GET[name]=value;});
	/*
    if(document.location.toString().indexOf('?') !== -1) {
        var query = document.location
            .toString()
            // get the query string
            .replace(/^.*?\?/, '')
            // and remove any existing hash string (thanks, @vrijdenker)
            .replace(/#.*$/, '')
            .split('&');

        for(var i=0, l=query.length; i<l; i++) {
            var aux = decodeURIComponent(query[i]).split('=');
            $_GET[aux[0]] = aux[1];
        }
    }*/


	if (!window.__productOrderModalHandlerAttached) {
		window.__productOrderModalHandlerAttached = true;
	}

	function showAlert(type, text, $scope) {
		const colors = {
			success: 'bg-success border-success text-white',
			error: 'bg-danger border-danger text-white',
			warning: 'bg-warning border-warning text-slate-900',
			info: 'bg-primary border-primary text-white'
		};

		const $root = ($scope && $scope.length) ? $scope : $(document);
		const $modalAlerts = $root.find('#new_order_modal_alerts');
		const $parent = $modalAlerts.length ? $modalAlerts : $('#product_order_form_wrapper');
		const cssClass = colors[type] || colors.error;

		$parent.find('.product-order-alert').remove();
		$parent.prepend('<div class="product-order-alert alert relative border rounded-md px-4 py-3 ' + cssClass + '">' + text + '</div>');
	}

	function getProductOrderModalInstance(modalElement) {
		if (!modalElement) {
			return null;
		}

		if (window.tailwind && tailwind.Modal && typeof tailwind.Modal.getOrCreateInstance === 'function') {
			return tailwind.Modal.getOrCreateInstance(modalElement);
		}

		return null;
	}

	function focusProductOrderModal() {
		window.setTimeout(function () {
			const $input = $('#new_order_modal #order_reference_number');
			if ($input.length) {
				$input.focus().select();
			}
		}, 150);
	}

	function openNewOrderModal() {
		const modal = document.querySelector('#new_order_modal');
		if (!modal) {
			return;
		}

		const cleanup = () => {
			$('#product_order_modal_wrapper').remove();
		};

		const modalInstance = getProductOrderModalInstance(modal);
		if (modalInstance) {
			modal.addEventListener('hidden.tw.modal', cleanup, { once: true });
			modalInstance.show();
			focusProductOrderModal();
			return;
		}

		const $modal = $(modal);
		$modal.addClass('show').attr('aria-hidden', 'false');
		$modal.find('[data-tw-dismiss="modal"]').on('click', function (e) {
			e.preventDefault();
			$modal.removeClass('show').attr('aria-hidden', 'true');
			cleanup();
		});
		focusProductOrderModal();
	}

	if (!window.__productOrderOpenHandlerAttached) {
		window.__productOrderOpenHandlerAttached = true;
		$(document).off('click', 'button#save_product_order');
		$(document).on('click', 'button#save_product_order', function () {
		console.log('[varebestilling] save_product_order clicked');
		let supplierId = $('select[name ="product_order_supplier_select"]').children("option:selected").val();

		$('div#product_order_modal_wrapper').remove();

		$.ajax({
			type: 'GET',
			url: ajaxPathGetProductsModal,
			data: {
				supplier_id: supplierId,
			},
			dataType: 'json'
		}).success(function (data) {
			$('body').append('<div id="product_order_modal_wrapper"></div>');
			$('div#product_order_modal_wrapper').append(data.html);
			openNewOrderModal();

		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		});
		});
	}

    if (!window.__productOrderSaveHandlerAttached) {
        window.__productOrderSaveHandlerAttached = true;
        $(document).off('click', '#new_order_modal #save_product_order_modal');
        $(document).on('click', '#new_order_modal #save_product_order_modal', function () {
        if (ajaxLocked) {
            return;
        }

        const $modal = $(this).closest('#new_order_modal');
        const $scope = $modal.length ? $modal : $('#new_order_modal').last();

        let supplierId = $('select[name="product_order_supplier_select"]').val();
        let orderReference = ($scope.find('#modal_order_reference_wrapper #order_reference_number').val() || '').trim();
        let companyName = ($scope.find('#modal_company_info_wrapper #company_name').val() || '').trim();
        let contactPersonName = ($scope.find('#modal_company_info_wrapper #company_contact_person').val() || '').trim();
        let contactPersonPhone = ($scope.find('#modal_company_info_wrapper #company_contact_phone').val() || '').trim();
        let contactPersonEmail = ($scope.find('#modal_company_info_wrapper #company_contact_email').val() || '').trim();

        // Required field validation
        if (!supplierId) {
            showAlert('error', 'Velg leverandør', $scope);
            return;
        }

        if (!orderReference) {
            showAlert('error', 'Ordrenummer / referanse mangler', $scope);
            return;
        }

        if (!companyName) {
            showAlert('error', 'Firmanavn mangler', $scope);
            return;
        }

        if (!contactPersonName) {
            showAlert('error', 'Kontaktperson mangler', $scope);
            return;
        }

        if (!contactPersonPhone) {
            showAlert('error', 'Telefonnummer mangler', $scope);
            return;
        }

        if (!contactPersonEmail) {
            showAlert('error', 'E-post mangler', $scope);
            return;
        }

        ajaxLocked = true;

        $.ajax({
            type: 'POST',
            url: ajaxPathSaveProductOrder,
            data: {
                supplier_id: supplierId,
                order_reference: orderReference,
                ordering_company_name: companyName,
                contact_person_name: contactPersonName,
                contact_person_phone: contactPersonPhone,
                contact_person_email: contactPersonEmail
            },
            dataType: 'json'
        })
            .done(function (data) {
                if (data && data.html) {
                    showAlert('success', data.html, $scope);
                }

                location.reload();
            })
            .fail(function (xhr) {
                let errorMessage = 'Noe gikk galt';

                try {
                    let response = JSON.parse(xhr.responseText);
                    if (response.errors) {
                        errorMessage = response.errors;
                    } else if (response.message) {
                        errorMessage = response.message;
                    }
                } catch (e) {
                    if (xhr.responseText) {
                        errorMessage = xhr.responseText;
                    }
                }

                showAlert('error', errorMessage, $scope);
            })
            .always(function () {
                ajaxLocked = false;
            });
        });
    }
	//If ENTER is clicked when searching for products, refresh form
	$('#product_order_form_wrapper #products-search').keyup(function(e) {
		let key = e.which;
		let searchInput = $('#product_order_form_wrapper #products-search');

		// Refresh list if enter was pressed
		if (key === 13 || searchInput.val() === '') {
			let url = updateURLParameter(window.location.href, "q", $("input#products-search").val());
			url = updateURLParameter(url, "page", 1);
			window.history.replaceState('', '', url);
			window.location.href = url;
		}
	});

	//If the product search button is clicked, refresh form
	$(document).on('click', '#product_order_form_wrapper #products-search-btn', function () {
		let url = updateURLParameter(window.location.href, "q", $("input#products-search").val());
		url = updateURLParameter(url, "page", 1);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//If the supplier select changes, refresh form
	$(document).on('change', "select[name='product_order_supplier_select']", function(){
		let tempSavedProductsFilter = $("select[name='temp_saved_products_filter']").val();
		let url = updateURLParameter(window.location.href, "supplier_id", $("select[name='product_order_supplier_select']").val());
		url = updateURLParameter(url, "page", 1);
		url = updateURLParameter(url, "show_temp_products", tempSavedProductsFilter);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//If the temp-saved-products-filter changes, refresh form
	$(document).on('change', "#product_order_form_wrapper select[name='temp_saved_products_filter']", function(){
		let supplierFilter = $("select[name='product_order_supplier_select']").val();
		let url = updateURLParameter(window.location.href, "show_temp_products", $("select[name='temp_saved_products_filter']").val());
		url = updateURLParameter(url, "page", 1);
		url = updateURLParameter(url, "supplier_id", supplierFilter);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//Send order by mail, open modal
    $(document).on('click', '#item_list_wrapper a.send_order_by_mail', function () {
        $('div#send_mail_modal_wrapper').remove();

        let productOrderId = $(this).parents('.list-item-product-order').first().attr("product_order_id");
        let isBackOrder = 0;

        $.ajax({
            type: 'GET',
            url: ajaxPathGetSendMailModal,
            data: {
                order_id: productOrderId,
                is_back_order: isBackOrder,
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#send_mail_modal_wrapper').remove();
            $('body').append('<div id="send_mail_modal_wrapper"></div>');
            $('div#send_mail_modal_wrapper').append(data.html);

            const modalEl = $('#send_email_modal');
            openTailwindModal(modalEl);

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    });

	//Delete (set status to deactivated) on product order
	$(document).on('click', '#item_list_wrapper a.delete-order', function (e) {
		e.preventDefault();

		if (ajaxLocked) {
			return;
		}

		if (!confirm("Er du sikker på at du vil slette denne varebestillingen?")) {
			return;
		}

		const $row = $(this).closest('tr.list-item-product-order');
		const productOrderId = $row.attr('product_order_id');

		if (!productOrderId) {
			displayInfoMessageModal(
				modalParentElementInDOM,
				'Det oppstod en feil!',
				'Kunne ikke finne bestillingen du prøvde å slette. Vennligst last siden på nytt ved å trykke f5 og prøv igjen.',
				modalButtonText,
				'error'
			);
			return;
		}

		deleteProductOrder(productOrderId, $row);
	});

	function openTailwindModal(modalEl) {
		if (!modalEl.length) {
			return;
		}

		const closeModal = () => {
			modalEl.removeClass('show').attr('aria-hidden', 'true');
			$('body').removeClass('modal-open');
			$('div#send_mail_modal_wrapper').remove();
		};

		modalEl.addClass('show').attr('aria-hidden', 'false');
		$('body').addClass('modal-open');

		modalEl.on('click', '[data-modal-close]', function (e) {
			e.preventDefault();
			closeModal();
		});

		modalEl.on('click', function (e) {
			if (e.target === modalEl[0]) {
				closeModal();
			}
		});
	}

	function deleteProductOrder(productOrderId, $row) {
		ajaxLocked = true;

		$.ajax({
			type: 'PUT',
			url: ajaxPathDeleteProductOrder,
			data: {
				product_order_id: productOrderId,
			},
			dataType: 'json'
		}).success(function () {
			if ($row && $row.length) {
				$row.remove();
			} else {
				location.reload();
			}
		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		}).always(function () {
			ajaxLocked = false;
		});
	}

	//Temp save amount on varebestilling
	$(document).on('change', 'input.product_amount', function () {
		let supplierId = $('select[name ="product_order_supplier_select"]').children("option:selected").val();
		let amount = $(this).val();
		let productId = $(this).attr("data-id");

		$.ajax({
			type: 'POST',
			url: ajaxPathTempSaveProduct,
			data: {
				supplier_id: supplierId,
				amount: amount,
				product_id: productId
			},
			dataType: 'json'
		}).success(function (data) {
			if (data.status !== 'OK') {
				let trRow = $('input[name="amount_' + productId + '"]').parent().parent();
				trRow.addClass('success');
				trRow.notify(data.status, {position:"left", className: "success"});

				const queryString = window.location.search;
				let urlParams = new URLSearchParams(queryString);
				let hideTrRow = urlParams.get('show_temp_products') === '0';
				if (hideTrRow) {
					trRow.hide(5500);
				}
			}


		}).error(function (data) {
			let row = $('input[name="amount_' + productId + '"]').parent().parent();
			let errorMessage = $.parseJSON(data.responseText).errors;
			row.removeClass('success');
			row.notify(errorMessage, {position:"left", className: "error"});
		});
	});

	//Send order by mail
    $(document).on('click', '#send_email_modal button#send_order_mail', function () {
        if (ajaxLocked) {
            return;
        }

        let supplierEmailAddress = $('#send_email_modal #supplier_email_modal').val();
        let copyEmailAddress = $('#send_email_modal #copy_email_modal').val();
        let productOrderId = $('#send_email_modal #order_id').val();
        let isBackOrder = $('#send_email_modal #is_back_order').val();

        ajaxLocked = true;

        $.ajax({
            type: 'POST',
            url: ajaxPathSendProductOrderMail,
            data: {
                supplier_email_address: supplierEmailAddress,
                copy_email_address: copyEmailAddress,
                order_id: productOrderId,
                is_back_order: isBackOrder
            },
            dataType: 'json'
        }).success(function (data) {
            $('#send_mail_modal_wrapper').remove();

            let element = $('div#left_side_form');
            if (copyEmailAddress === '') {
                displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.', 'success', element);
            } else {
                displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.<br/> Kopi sendt til: ' + copyEmailAddress + '.', 'success', element);
            }
        }).error(function (data) {
            console.log('RAW RESPONSE:', data.responseText);

            let element = $('#send_email_modal_content');
            let errorMessage = 'Det oppstod en ukjent feil.';

            try {
                let parsed = JSON.parse(data.responseText);
                if (parsed.errors) {
                    errorMessage = parsed.errors;
                }
            } catch (e) {
                console.log('Response is not valid JSON');
            }

            displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
        }).always(function () {
            ajaxLocked = false;
        });
    });

	//Get search result for Product Order when button is clicked
	$(document).on('click', '#product_order_list_wrapper #product_order_search_button', function () {
		if ($('#product_order_list_wrapper #product_order_search_input').val() !== '') {
			getSearchResult();
		}
	});

	//Get search result for Product Order when ENTER is pressed or input is removed
	$('#product_order_list_wrapper #product_order_search_input').keyup(function(e) {
		let key = e.which;
		let searchInput = $('#product_order_list_wrapper #product_order_search_input');

		// Refresh list if enter was pressed or the search field is empty
		if (key === 13 || searchInput.val() === '') {
			getSearchResult();
		}
	});

	/**
	 * Functions
	 */

	function updateURLParameter(url, param, paramVal){
		var newAdditionalURL = "";
		var tempArray = url.split("?");
		var baseURL = tempArray[0];
		var additionalURL = tempArray[1];
		var temp = "";
		if (additionalURL) {
			tempArray = additionalURL.split("&");
			for (var i=0; i<tempArray.length; i++){
				if(tempArray[i].split('=')[0] != param){
					newAdditionalURL += temp + tempArray[i];
					temp = "&";
				}
			}
		}

		var rows_txt = temp + "" + param + "=" + paramVal;
		return baseURL + "?" + newAdditionalURL + rows_txt;
	}

	/**
	 * Check input from user and get result from search
	 */
	function getSearchResult() {
		if (ajaxLocked) {
			return;
		}
		let searchString = $('#product_order_list_wrapper #product_order_search_input').val();

		ajaxLocked = true;
		$.ajax({
			type: 'GET',
			url: ajaxPathGetSearchResult,
			data: {
				search_string: searchString,
			},
			dataType: 'json'
		}).success(function (data) {
			$('#product_order_list_wrapper #item_list_wrapper').replaceWith(data.html);

		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		}).always(function (data) {
			ajaxLocked = false;
		});
	}
});
